import React, { useEffect, useState } from 'react'
import styles from '../styles'
import { withStyles, Typography } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import { useDispatch } from 'react-redux'
import { MailPreparation, MailSent, MailCName } from '../index'

import { sendMailToLearnerAction } from 'src/reducers/teams/action'
import { Icon } from '@iconify/react'
import { track } from '@amplitude/analytics-browser'
import { PatchContent, PatchData } from 'src/model/patch'
import { patchCollectionSettingsAction } from 'src/reducers/collection/action'
import { defaultEmailSettings } from 'src/model/languages'
import { languages } from 'src/model/languages'

const MagicViewContent = props => {
  const { entity, handleBack, closeDrawer, collectionSettings, classes } = props

  const dispatch = useDispatch()

  const [mailSent, setMailSent] = React.useState(false)
  const sendMail = () => {
    dispatch(
      sendMailToLearnerAction(
        entity.id,
        sendLinkToNewMembersOnly,
        null,
        response => setMailSent(true),
      ),
    )
    track('magiclink_email_sent')
  }
  const [
    sendLinkToNewMembersOnly,
    setSendLinkToNewMembersOnly,
  ] = React.useState(collectionSettings.sendLinkToNewMembersOnly)

  const handleSendLinkToNewMembersOnly = value => {
    setSendLinkToNewMembersOnly(value)
    const patchSource = new PatchData(null, entity.id)
    patchSource.addContent(
      new PatchContent(
        value,
        'sendLinkToNewMembersOnly',
        PatchData.OPERATION_REPLACE,
      ),
    )

    dispatch(patchCollectionSettingsAction(patchSource, response => {}))
  }
  const [emailText, setEmailText] = React.useState(
    collectionSettings.inviteEmailBody,
  )
  const [emailSettings, setEmailSettings] = useState()
  const languageOptions = languages

  // Invite emails are sent in the workspace language (Workspace > Language);
  // the path's saved language only picks the fallback subject here.
  const languageSelection = languageOptions.find(
    collectionSettings.countryCode
      ? x => x.countryCode === collectionSettings.countryCode
      : x => x.countryCode === 'en',
  )

  const [emailTitle, setEmailTitle] = useState(
    collectionSettings.inviteEmailSubject != null
      ? collectionSettings.inviteEmailSubject
      : emailSettings &&
          emailSettings[languageSelection.countryCode].find(
            x => x.key == 'invite_member_subject',
          ).text,
  )

  useEffect(() => {
    if (emailSettings) return
    const grouped = defaultEmailSettings.reduce((acc, item) => {
      acc[item.countryCode] = acc[item.countryCode] || []
      acc[item.countryCode].push(item)
      return acc
    }, {})
    setEmailSettings(grouped)
  }, [emailSettings])

  useEffect(() => {
    emailSettings &&
      emailTitle == null &&
      setEmailTitle(
        emailSettings[languageSelection.countryCode].find(
          x => x.key == 'invite_member_subject',
        ).text,
      )
  }, [emailSettings])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 16,
      }}
    >
      {mailSent ? (
        <>
          <MailSent closeDrawer={closeDrawer} handleBack={handleBack} />
        </>
      ) : (
        <>
          <div
            className={classes.displayF}
            style={{ marginBottom: 24 }}
            onClick={() => handleBack()}
          >
            <Icon
              icon={'material-symbols:arrow-back-ios-rounded'}
              className={classes.magic_link_icon}
              style={{ cursor: 'pointer' }}
            />
            <Typography
              fontSize={'15px'}
              fontWeight={600}
              style={{ color: '#002E47' }}
            >
              Invite learners by magic link
            </Typography>
          </div>

          <Typography
            fontSize={'15px'}
            fontWeight={600}
            style={{ color: '#002E47' }}
          >
            Email Settings
          </Typography>

          <div
            style={{
              background: '#F4F6F8',
              padding: 16,
              gap: 16,
              borderRadius: 8,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <MailPreparation
              handleSendLinkToNewMembersOnly={handleSendLinkToNewMembersOnly}
              sendLinkToNewMembersOnly={sendLinkToNewMembersOnly}
              entity={entity}
              collectionSettings={collectionSettings}
              dispatch={dispatch}
              emailText={emailText}
              setEmailText={setEmailText}
              emailTitle={emailTitle}
              setEmailTitle={setEmailTitle}
            />
          </div>
          <Typography
            fontSize={'15px'}
            fontWeight={600}
            style={{ color: '#002E47' }}
          >
            Custom Domain Settings
          </Typography>
          <div
            style={{
              background: '#F4F6F8',
              padding: 16,
              gap: 16,
              borderRadius: 8,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <MailCName
              handleSendLinkToNewMembersOnly={handleSendLinkToNewMembersOnly}
              sendLinkToNewMembersOnly={sendLinkToNewMembersOnly}
              entity={entity}
              collectionSettings={collectionSettings}
              dispatch={dispatch}
              emailText={emailText}
              setEmailText={setEmailText}
              emailTitle={emailTitle}
              setEmailTitle={setEmailTitle}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: 16,
            }}
          >
            <CoreButton
              variant={'contained'}
              onClick={() => handleBack()}
              color="disabled"
            >
              Back
            </CoreButton>
            <CoreButton
              variant={'contained'}
              onClick={() => collectionSettings.teams.length != 0 && sendMail()}
              color={
                collectionSettings.teams.length == 0 ? 'disabled' : 'success'
              }
            >
              Send Mail
            </CoreButton>
          </div>
        </>
      )}
    </div>
  )
}

export default withStyles(styles)(MagicViewContent)
